import {
  ODSGlobalHeaderIconMenu,
  ODSGlobalHeaderIconButton,
} from '@telekom-ods/react-ui-kit';
import { useKeycloak } from '@react-keycloak/web';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import useAppContext from '../../hooks/useAppContext';
import Tooltip from '../Tooltip/Tooltip';

const IconMenu = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { toggleTheme, cookiesAccepted, theme } = useAppContext();
  const { authenticated, idTokenParsed, idToken } = keycloak;

  const themeIcon = useMemo(
    () => (theme === 'dark' ? 'light-dark-mode-type-standard' : 'light-dark-mode-type-bold'),
    [theme],
  );

  return (
    <ODSGlobalHeaderIconMenu>
      <Tooltip title={!cookiesAccepted ? intl.formatMessage({ id: 'privacyPolicyConfirmation' }) : ''}>
        <ODSGlobalHeaderIconButton
          icon="user"
          label={authenticated ? idTokenParsed?.email : 'Login'}
          onClick={
            authenticated
              ? () => navigate('/account')
              : () => keycloak.login({ redirectUri: window.location.origin })
          }
          disabled={!cookiesAccepted}
        />
      </Tooltip>
      {authenticated && (
        <ODSGlobalHeaderIconButton
          icon="logout"
          label="Logout"
          onClick={() => keycloak.logout({
            redirectUri: window.location.origin,
            idTokenHint: idToken,
          })}
        />
      )}
      <ODSGlobalHeaderIconButton icon={themeIcon} onClick={toggleTheme} />
    </ODSGlobalHeaderIconMenu>
  );
};

export default IconMenu;
